import { createApp } from 'vue'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import App from './App.vue'

const app = createApp(App)
import en from 'element-plus/es/locale/lang/en'

app.use(ElementPlus, {
  locale: en,
})
app.mount('#app')